module.exports = __webpack_public_path__ + "static/media/18ECA25.0ed69523.jpg";